// extracted by mini-css-extract-plugin
export var measureBox = "_84-0";